
import React from 'react';
import { TrendingUp } from 'lucide-react';
import { AnalysisResult } from './types';

type ExecutiveSummaryProps = {
  summary: string;
};

const ExecutiveSummary = ({ summary }: ExecutiveSummaryProps) => {
  return (
    <div className="bg-gradient-to-r from-indigo-900/30 to-purple-900/30 rounded-lg p-6 backdrop-blur-md border border-indigo-500/20">
      <div className="flex items-start gap-4">
        <div className="bg-indigo-600/20 p-3 rounded-full">
          <TrendingUp className="h-6 w-6 text-indigo-400" />
        </div>
        <div>
          <h3 className="text-lg font-semibold text-white mb-2">
            Executive Summary
          </h3>
          <p className="text-white leading-relaxed">
            {summary}
          </p>
        </div>
      </div>
    </div>
  );
};

export default ExecutiveSummary;
